import React from "react";

/**
 * Runtime feature-flag configuration distributed to all child components via
 * React context. Phase 1 capability entry points default fail-closed until a
 * prop fallback or OpenFeature/GrowthBook provider explicitly enables them.
 */
export interface RuntimeConfig {
  genesysLiveChatEnabled: boolean;
  genesysLiveChatQueueDisplayEnabled: boolean;
  sidePanelShellEnabled: boolean;
  enrollmentConsultationEnabled: boolean;
  /** Controls Legal-approved canned thinking insights. */
  thinkingInsightsEnabled: boolean;
}

const DEFAULT_RUNTIME_CONFIG: RuntimeConfig = {
  genesysLiveChatEnabled: false,
  genesysLiveChatQueueDisplayEnabled: false,
  sidePanelShellEnabled: false,
  enrollmentConsultationEnabled: false,
  thinkingInsightsEnabled: false,
};

export const RuntimeConfigContext = React.createContext<RuntimeConfig>(DEFAULT_RUNTIME_CONFIG);

export const useRuntimeConfig = (): RuntimeConfig => React.useContext(RuntimeConfigContext);
